import React, {Component} from 'react';
import PreloaderDog from './PreloaderDog';

class LoaderWait extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div id="modal-container" className="out">
                <div className="modal-background">
                    <div className="modal">
                        <h1 className="message-modal">{this.props.message}</h1>
                        <PreloaderDog/>
                    </div>
                </div>
            </div>
        )
    }

    componentDidMount() {
        console.log("LoaderWait::componentDidMount()");
        // if (this.props.stepWaitBlock === 0) {
            $("#modal-container").removeClass("out").one("webkitAnimationEnd oAnimationEnd msAnimationEnd animationend", (event) => {
                // if (this.props.stepWaitBlock === 0) {
                //     this.props.changeStepWaitBlock(1);
                //     if (this.props.methodChange) {
                //         this.props.methodChange("go");
                //     }
                // }
            });
        // }
        // this.stepClosed = 0;
    }

    componentDidUpdate() {
        console.log("LoaderWait::componentDidUpdate()");

        console.log("this.props.stepWaitBlock = '" + this.props.stepWaitBlock + "'");
        // if (this.props.stepWaitBlock > 1 || this.props.stepWaitBlock.length === 24) {
        //     if (this.props.stepWaitBlock > 1 && this.props.stepWaitBlock < 100) {
        //         this.props.methodChange(this.props.stepWaitBlock);
        //     } else {
                var that = this;
                $("#modal-container").on("webkitAnimationEnd oAnimationEnd msAnimationEnd animationend", (event) => {
                    // if (this.stepClosed === 1) {
                        $("body").removeClass("modal-active");
                        // this.stepClosed = 2;
                        // this.props.methodChange(that.props.stepWaitBlock);
                    // } else {
                    //     this.stepClosed = 1;
                    // }
                });
                $("body").removeClass("modal-active");
                // $("#modal-container").addClass("out");
                // this.props.methodChange(that.props.stepWaitBlock);
            // }
        // }
    }
}


export default LoaderWait
